<template>
  <div class="main-content">

    <EmptyCardModal
      v-if="modalData"
      ref="modal"
      :modalData="modalData"
      :onModalClose="(reset) => modalData = null"
      :onModalAccept="() => updateRecord()"
    >
      <slot>
        <EditPhone ref="editPhone" :record="modalData.data"/>
      </slot>
    </EmptyCardModal>

    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-3"/>
        <template v-if="records && records.length">
          <table class="table mt-1 table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Номер</th>
              <th>Слот</th>
              <th>Оператор</th>
              <th>Доступ</th>
              <th>Расходы</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r, i) in records">
              <td>{{ i + 1 }}</td>
              <td>{{ r.phone_number }}</td>
              <td>{{ r.slot }}</td>
              <td>{{ r.operator }} <a :href="`${operatorsLogin[r.operator]}`" target="_blank"><i
                class="icon-fa icon-fa-globe"/></a>
              </td>
              <td>
                <p>{{ r.extra && r.extra.comment }}</p>
                <template v-if="r.extra && r.extra.login">
                  <button v-if="!showAccess[r.id]" @click="showAccess[r.id] = true" class="btn btn-default">показать
                    доступ
                  </button>
                  <template v-if="showAccess[r.id]">
                    <p>{{ r.extra.login }}</p>
                    <p>{{ r.extra.pass }}</p>
                  </template>
                </template>
              </td>
              <td>
                <div v-for="exp in r.expenses" v-if="exp.is_active" class="exp_div">
                  <p>{{ exp.period }} / {{ exp.period_type === 'month' ? 'месяц' : 'дней' }} <strong>{{
                      exp.sum
                    }}</strong>
                    {{ exp.comment }}</p>
                  <p class="text-muted text-right">{{ printDate(exp.created_at, 'DD.MM.YYYY HH:mm') }}</p>
                </div>
              </td>
              <td>
                <button @click="editRecord(r)" type="button" class="btn btn-xs btn-outline-success">редактировать
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import EmptyCardModal from "@/components/modals/EmptyCardModal";
import EditPhone from "@/views/telephony/components/EditPhone";

export default {
  components: {
    EmptyCardModal,
    EditPhone,
  },
  data() {
    return {
      records: [],
      loading: false,
      showAccess: {},
      modalData: null,
      operatorsLogin: {
        'MTS': 'https://login.mts.ru',
        'Beeline': 'https://moskva.beeline.ru/login/'
      },
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async updateRecord() {
      this.$refs.modal.acceptBtnLoading = true;
      const result = await this.$refs.editPhone.updatePhone();
      this.$refs.modal.acceptBtnLoading = false;
      if (result) {
        this.modalData = null;
        this.getRecords();
      }
    },
    editRecord(record) {
      this.modalData = {
        header: 'Редактирование телефона',
        data: record,
      }
    },
    async getRecords(page = 1) {
      this.loading = true;
      const {data} = await api.index('/telephony/bankPhones');
      if (data.success) {
        this.showAccess = data.records.reduce((acc, r) => {
          acc[r.id] = false;
          return acc;
        }, {})
        this.records = data.records;
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
table.table td {
  padding: 3px;
}

.exp_div p {
  margin-bottom: 2px;
}

</style>
